import React, { useState } from 'react';
import Measure from 'react-measure';
import { calculateLegendWidth } from './helpers';

const MIN_WIDTH = 1360;

function ChartDimensions({ meta, dynamic = true, children }) {
  const [dimensions, setDimensions] = useState(() => {
    if (dynamic) {
      return { width: 0, height: 0 };
    } else {
      const approximateLegendWidth = calculateLegendWidth({ meta });

      const staticWidth = Math.max(MIN_WIDTH, approximateLegendWidth * 4);
      const staticHeight = (staticWidth * 9) / 16;

      return { width: staticWidth, height: staticHeight };
    }
  });

  const { width, height } = dimensions;

  return (
    <Measure
      bounds
      onResize={({ bounds }) => {
        if (dynamic) {
          setDimensions({ height: bounds.height, width: bounds.width });
        }
      }}
    >
      {({ measureRef }) => children({ measureRef, width, height })}
    </Measure>
  );
}
export default ChartDimensions;
